<div class="flex flex-col min-h-screen p-3 sm:p-6 overflow-x-hidden max-w-full" *transloco="let t">
  <!-- Título da Página -->
  <div class="mb-4 sm:mb-8">
    <h4 class="text-left text-lg sm:text-xl font-bold">{{ t('qrScanner.title') }}</h4>
  </div>

  <!-- Tela: aguardando o operador confirmar no computador -->
  <div *ngIf="currentStep === 'confirming'" class="flex flex-col items-center">
    <div class="bg-blue-50 border border-blue-200 p-6 max-w-md w-full text-center">
      <p class="text-sm text-gray-700 mb-1">{{ t('qrScanner.typeOnDesktop') }}</p>
      <p *ngIf="stationCode" class="text-xs text-gray-500 mb-4">
        {{ t('qrScanner.station') }} <span class="font-mono font-bold">{{ stationCode }}</span>
      </p>

      <div *ngIf="confirmationCode" class="py-4">
        <span class="text-5xl font-mono font-bold tracking-widest text-gray-800">{{ confirmationCode }}</span>
      </div>

      <div *ngIf="!confirmationCode" class="py-6">
        <p class="text-sm text-gray-500">{{ t('qrScanner.pairing') }}</p>
      </div>

      <p *ngIf="confirmSecondsLeft > 0" class="text-xs text-gray-500 mt-2">
        {{ t('qrScanner.waitingConfirmation', { seconds: confirmSecondsLeft }) }}
      </p>

      <p class="text-xs text-gray-400 mt-4">{{ t('qrScanner.codeOnlyHere') }}</p>
    </div>
  </div>

  <!-- Tela: Pareando -->
  <div *ngIf="currentStep === 'pairing'" class="flex flex-col items-center">
    <div class="bg-blue-50 border border-blue-200 p-6 max-w-md w-full text-center">
      <svg class="w-8 h-8 mx-auto mb-3 text-blue-600 animate-pulse" fill="none" stroke="currentColor" viewBox="0 0 24 24">
        <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M12 4v1m6 11h2m-6 0h-2v4m0-11v3m0 0h.01M12 12h4.01M16 20h4M4 12h4m12 0h.01M5 8h2a1 1 0 001-1V5a1 1 0 00-1-1H5a1 1 0 00-1 1v2a1 1 0 001 1z"></path>
      </svg>
      <p class="text-sm font-medium text-gray-700">{{ t('qrScanner.pairing') }}</p>
    </div>
  </div>

  <!-- Tela: Escanear QR Code da Sessão -->
  <div *ngIf="currentStep === 'scan-session'" class="flex flex-col items-center">
    <div class="bg-blue-50 border border-blue-200 p-6 max-w-md w-full">
      <h5 class="text-lg font-semibold text-gray-800 mb-4 text-center">{{ t('qrScanner.connectToSession') }}</h5>

      <!-- Falha de pareamento -->
      <div *ngIf="pairingError" class="mb-4 p-3 bg-red-50 border border-red-200">
        <p class="text-sm text-red-600">{{ pairingError }}</p>
      </div>

      <!-- Área do Scanner de Sessão - Movida para cima -->
      <div *ngIf="isScanningSession" class="mb-4 flex justify-center w-full max-w-full overflow-hidden">
        <div id="session-qr-reader" class="w-full max-w-full overflow-hidden border-2 border-blue-500" style="min-height: 300px; max-width: 100%;"></div>
      </div>

      <!-- Loading enquanto inicializa -->
      <div *ngIf="isScanningSession && !cameraPermissionDenied" class="mb-4 text-center">
        <p class="text-sm text-gray-600">{{ t('qrScanner.initializingCamera') }}</p>
      </div>

      <!-- Mensagem de erro de permissão -->
      <div *ngIf="cameraPermissionDenied" class="mb-4 p-3 bg-red-50 border border-red-200">
        <p class="text-sm text-red-600">
          {{ t('qrScanner.cameraDenied') }}
        </p>
      </div>

      <p class="text-sm text-gray-600 mb-4 text-center">
        {{ t('qrScanner.scanSessionInstruction') }}
      </p>

      <button 
        type="button"
        (click)="startSessionScanner()"
        [disabled]="isScanningSession"
        class="w-full px-4 py-3 bg-blue-600 text-white font-medium transition-colors disabled:bg-gray-400 disabled:cursor-not-allowed flex items-center justify-center gap-2">
        <svg *ngIf="!isScanningSession" class="w-5 h-5" fill="none" stroke="currentColor" viewBox="0 0 24 24">
          <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M3 9a2 2 0 012-2h.93a2 2 0 001.664-.89l.812-1.22A2 2 0 0110.07 4h3.86a2 2 0 011.664.89l.812 1.22A2 2 0 0018.07 7H19a2 2 0 012 2v9a2 2 0 01-2 2H5a2 2 0 01-2-2V9z"></path>
          <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M15 13a3 3 0 11-6 0 3 3 0 016 0z"></path>
        </svg>
        <svg *ngIf="isScanningSession" class="w-5 h-5 animate-pulse" fill="none" stroke="currentColor" viewBox="0 0 24 24">
          <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M21 21l-6-6m2-5a7 7 0 11-14 0 7 7 0 0114 0z"></path>
        </svg>
        <span class="text-center">{{ isScanningSession ? t('qrScanner.scanning') : t('qrScanner.scanQrCode') }}</span>
      </button>
    </div>
  </div>

  <!-- Tela: Conectado e Escaneando Produtos -->
  <div *ngIf="currentStep === 'connected' && deviceState" class="flex flex-col">
    <!-- Estação fora do ar: continua pareado, só não dá para bipar agora -->
    <div *ngIf="!stationOnline" class="mb-4 p-3 bg-amber-50 border border-amber-200">
      <p class="text-sm text-amber-800 font-medium">{{ t('qrScanner.stationOffline') }}</p>
      <p class="text-xs text-amber-700 mt-1">{{ t('qrScanner.stationOfflineHint') }}</p>
    </div>

    <!-- Área do Scanner de Produtos - No topo -->
    <div *ngIf="isScanningProduct" class="mb-4 flex justify-center w-full max-w-full overflow-hidden">
      <div id="product-qr-reader" class="w-full max-w-full overflow-hidden border-2 border-green-500" style="max-width: 100%;"></div>
    </div>

    <!-- Status de processamento -->
    <div *ngIf="isProcessingQRCode" class="mb-4 text-center py-2">
      <span class="text-sm text-blue-600 font-medium">{{ t('qrScanner.sendingQrCode') }}</span>
    </div>

    <!-- Controles do Scanner -->
    <div class="bg-white border border-gray-200 p-4 mb-4">
      <button 
        type="button"
        (click)="isScanningProduct ? stopProductScanner() : startProductScanner()"
        [disabled]="isProcessingQRCode"
        [class.bg-green-600]="isScanningProduct"
        [class.bg-blue-600]="!isScanningProduct"
        [class.hover:bg-green-700]="isScanningProduct"
        [class.hover:bg-blue-700]="!isScanningProduct"
        class="w-full px-4 py-3 text-white font-medium transition-colors disabled:bg-gray-400 disabled:cursor-not-allowed flex items-center justify-center gap-2 mb-3">
        <svg *ngIf="!isScanningProduct" class="w-5 h-5" fill="none" stroke="currentColor" viewBox="0 0 24 24">
          <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M3 9a2 2 0 012-2h.93a2 2 0 001.664-.89l.812-1.22A2 2 0 0110.07 4h3.86a2 2 0 011.664.89l.812 1.22A2 2 0 0018.07 7H19a2 2 0 012 2v9a2 2 0 01-2 2H5a2 2 0 01-2-2V9z"></path>
          <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M15 13a3 3 0 11-6 0 3 3 0 016 0z"></path>
        </svg>
        <svg *ngIf="isScanningProduct" class="w-5 h-5 animate-pulse" fill="none" stroke="currentColor" viewBox="0 0 24 24">
          <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M21 21l-6-6m2-5a7 7 0 11-14 0 7 7 0 0114 0z"></path>
        </svg>
        <span>{{ isScanningProduct ? t('qrScanner.stopScanner') : t('qrScanner.startScanner') }}</span>
      </button>
      
      <!-- Informações da Sessão e Desconectar - Sempre visível quando conectado -->
      <div *ngIf="deviceState?.isConnected" class="bg-green-50 border border-green-200 p-3 mb-3">
        <div class="flex items-center justify-between">
          <div class="flex-1 min-w-0">
            <p class="text-sm font-medium text-gray-700 truncate">
              {{ t('qrScanner.station') }} <span class="font-mono font-bold">{{ deviceState.stationCode }}</span>
            </p>
            <p class="text-xs text-gray-500 truncate">{{ t('qrScanner.sessionConnected') }}</p>
          </div>
          <button
            type="button"
            (click)="disconnectFromSession()"
            class="px-3 py-1.5 bg-red-600 text-white text-sm font-medium hover:bg-red-700 transition-colors whitespace-nowrap flex-shrink-0 ml-2">
            {{ t('qrScanner.disconnect') }}
          </button>
        </div>
      </div>
    </div>

    <!-- Histórico de Envios -->
    <div class="bg-gray-50 border border-gray-200 p-4">
      <h5 class="text-lg font-semibold text-gray-800 mb-3">{{ t('qrScanner.sendHistory') }}</h5>

      <div *ngIf="sendHistory.length === 0" class="text-center py-4">
        <span class="text-sm text-gray-500">{{ t('qrScanner.noSendsYet') }}</span>
      </div>

      <div *ngIf="sendHistory.length > 0" class="space-y-2 max-h-64 overflow-y-auto">
        <div *ngFor="let item of sendHistory" 
             [class.bg-green-50]="item.success"
             [class.bg-red-50]="!item.success"
             class="border p-3">
          <div class="flex items-center justify-between">
            <div class="flex-1">
              <p class="text-sm font-medium break-all">{{ item.qrCode }}</p>
              <p class="text-xs text-gray-500 mt-1">{{ formatDate(item.sentAt) }}</p>
            </div>
            <div>
              <span *ngIf="item.success" class="text-green-600 text-sm font-medium">✓ {{ t('qrScanner.sent') }}</span>
              <span *ngIf="!item.success" class="text-red-600 text-sm font-medium">✗ {{ t('qrScanner.errorShort') }}</span>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</div>

